import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const EObchodnik = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M14.5,10 C16.9852814,10 19,12.0147186 19,14.5 C19,16.9852814 16.9852814,19 14.5,19 C12.0147186,19 10,16.9852814 10,14.5 C10,12.0147186 12.0147186,10 14.5,10 Z M15.9142136,12.3786797 L14.5,13.7928932 L13.0857864,12.3786797 L12.3786797,13.0857864 L13.7928932,14.5 L12.3786797,15.9142136 L13.0857864,16.6213203 L14.5,15.2071068 L15.9142136,16.6213203 L16.6213203,15.9142136 L15.2071068,14.5 L16.6213203,13.0857864 L15.9142136,12.3786797 Z M5.5,10 C7.98528137,10 10,12.0147186 10,14.5 C10,16.9852814 7.98528137,19 5.5,19 C3.01471863,19 1,16.9852814 1,14.5 C1,12.0147186 3.01471863,10 5.5,10 Z M6.91421356,12.3786797 L3.37867966,15.9142136 L4.08578644,16.6213203 L7.62132034,13.0857864 L6.91421356,12.3786797 Z M5.5,1 C7.98528137,1 10,3.01471863 10,5.5 C10,7.98528137 7.98528137,10 5.5,10 C3.01471863,10 1,7.98528137 1,5.5 C1,3.01471863 3.01471863,1 5.5,1 Z M6,3 L5,3 L5,5 L3,5 L3,6 L5,6 L5,8 L6,8 L6,6 L8,6 L8,5 L6,5 L6,3 Z M14.5,1 C16.9852814,1 19,3.01471863 19,5.5 C19,7.98528137 16.9852814,10 14.5,10 C12.0147186,10 10,7.98528137 10,5.5 C10,3.01471863 12.0147186,1 14.5,1 Z M17,5 L12,5 L12,6 L17,6 L17,5 Z"
				id="eObchodnik"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

EObchodnik.propTypes = {
	color: PropTypes.string,
};

export default EObchodnik;
